import React from 'react'
import styled from 'styled-components'
import checkBlueCircle from '../public/static/images/svg/checkBlueCircleIcon.svg'

const CenterContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  color: ${props => props.theme.colors.primary};
  font-family: ${props => props.theme.fonts.avenirNextDemi};
  font-size: 1.125rem;
`

const CheckIcon = styled.img`
  margin-right: 10px;
  width: 22px;
  height: 22px;
`

const Success = () => {
  return (
    <CenterContainer>
      <CheckIcon
        src={checkBlueCircle}
        alt="Check!"
      />
      {' '}
      Success!
    </CenterContainer>
  )
}

export default Success
